import { render, staticRenderFns } from "./CoronaCountries.vue?vue&type=template&id=30823010&"
import script from "./CoronaCountries.vue?vue&type=script&lang=js&"
export * from "./CoronaCountries.vue?vue&type=script&lang=js&"
import style0 from "./CoronaCountries.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports